<template>
  <v-dialog
      v-model="dialog"
      max-width="1024"
      persistent
  >
    <v-card>
      <v-card-title class="headline">Registrar expediente</v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-stepper
            v-model="currentStep"
            flat
        >
          <v-stepper-header>
            <v-stepper-step
                :complete="currentStep > 1"
                step="1"
            >
              Información personal
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="currentStep > 2"
                step="2"
            >
              Perfil del paciente
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="currentStep > 3"
                step="3"
            >
              Información adicional
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                step="4"
            >
              Detalles de la tabla
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>

            <!-- Step 1: Personal Information -->
            <v-stepper-content step="1">
              <v-form ref="formCreateClient">
                <v-row class="mt-2">
                  <v-col cols="12" md="6">
                    <v-text-field
                        v-model="client.name"
                        label="Nombre completo *"
                        outlined
                        dense
                        required
                        :rules="[rules.required, rules.nameCounter]"
                    />
                  </v-col>

                  <v-col cols="12">
                    <div class="v-label theme--light pb-2 text-sm">
                      Fecha de nacimiento *
                    </div>
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-text-field
                            v-model.number="selectedDay"
                            hide-spin-buttons
                            label="Día *"
                            type="number"
                            outlined
                            dense
                            required
                            :rules="dayRules"
                            @input="updateBirthdate"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                            v-model="selectedMonth"
                            :items="months"
                            item-text="text"
                            item-value="value"
                            label="Mes *"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                            @input="updateBirthdate"
                            no-data-text="Mes no válido"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                            v-model="selectedYear"
                            :items="years"
                            label="Año *"
                            outlined
                            dense
                            required
                            :rules="[rules.required]"
                            @input="updateBirthdate"
                            no-data-text="Año no válido"
                        />
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-list-item-content class="pt-0">
                          <v-list-item-title>
                            Edad:
                          </v-list-item-title>
                          <v-list-item-subtitle class="body-2">
                            {{ currentAgeDisplay || "Ingresa una fecha válida" }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="client.gender"
                        label="Sexo biológico *"
                        :rules="[rules.required]"
                        class="mt-0"
                    >
                      <v-radio
                          label="Masculino"
                          value="MALE"
                          on-icon="mdi-gender-male"
                      />
                      <v-radio
                          label="Femenino"
                          value="FEMALE"
                          on-icon="mdi-gender-female"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="client.type"
                        label="Tipo de cliente *"
                        :rules="[rules.required]"
                        class="mt-0"
                    >
                      <v-radio
                          label="Presencial"
                          value="PRESENTIAL"
                          on-icon="mdi-account-circle-outline"
                          color="purple"
                      />
                      <v-radio
                          label="En línea"
                          value="REMOTE"
                          on-icon="mdi-web"
                          color="blue"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model="client.occupation"
                        label="Ocupación *"
                        outlined
                        dense
                        :rules="[rules.required, rules.counter]"
                        :prepend-inner-icon="'mdi-briefcase-outline'"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model="client.phone"
                        label="Teléfono *"
                        outlined
                        dense
                        maxlength="12"
                        :rules="[rules.phone, rules.required]"
                        :prepend-inner-icon="'mdi-phone-outline'"
                        @input="formatPhone(client.phone)"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                        v-model="client.province"
                        :items="provinces"
                        label="Estado *"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                        v-model="client.city"
                        :items="cities"
                        label="Municipio *"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                        :disabled="!client.province"
                        v-if="client.province !== 'Otro / Extranjero'"
                    />
                    <v-text-field
                        v-model="client.city"
                        label="Ciudad *"
                        outlined
                        dense
                        required
                        :rules="[rules.required]"
                        v-else
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model="client.district"
                        :label="client.province !== 'Otro / Extranjero' ? 'Colonia *' : 'Distrito *'"
                        outlined
                        dense
                        required
                        :rules="[rules.required, rules.counter]"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 2: File Information -->
            <v-stepper-content step="2">
              <v-form ref="formRegisterFile">
                <v-row class="mt-2">
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model.number="client.heightCm"
                        label="Estatura (cm)"
                        outlined
                        dense
                        type="number"
                        :rules="[rules.required, rules.centimeter]"
                        prepend-inner-icon="mdi-ruler"
                        min="70"
                        max="250"
                        placeholder="170"
                        hide-spin-buttons
                        suffix="cm"
                        @keydown="preventNonNumeric($event)"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model.number="client.initialWeightKg"
                        label="Peso actual (kg)"
                        outlined
                        dense
                        type="number"
                        :rules="[rules.required, rules.kilogram]"
                        prepend-inner-icon="mdi-weight"
                        min="30"
                        max="400"
                        placeholder="80.0"
                        hide-spin-buttons
                        suffix="kg"
                        @keydown="preventNonNumeric($event)"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model.number="wristCircumference"
                        label="Circunferencia de la muñeca (cm)"
                        outlined
                        dense
                        type="number"
                        :rules="[rules.required, rules.wrist]"
                        prepend-inner-icon="mdi-tape-measure"
                        min="10"
                        max="30"
                        placeholder="15"
                        hide-spin-buttons
                        suffix="cm"
                        @keydown="preventNonNumeric($event)"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                        v-model.number="client.desiredWeightKg"
                        label="Peso deseado (kg)"
                        outlined
                        dense
                        type="number"
                        :rules="[rules.required, rules.kilogram]"
                        prepend-inner-icon="mdi-bullseye-arrow"
                        min="30"
                        max="400"
                        placeholder="80"
                        hide-spin-buttons
                        suffix="kg"
                        @keydown="preventNonNumeric($event)"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-list-item>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title>
                          Peso ideal:
                        </v-list-item-title>
                        <v-list-item-subtitle class="body-2">
                          <span v-if="idealWeight">
                            <strong>
                              {{ idealWeight.toFixed(3) }} kg
                            </strong>
                            <small class="orange--text">
                              (Sobrepeso: {{ overweight.toFixed(3) }} kg)
                            </small>
                          </span>
                          <span v-else>
                            N/A
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-list-item>
                      <v-list-item-content class="pt-0">
                        <v-list-item-title>
                          Índice de masa corporal (IMC):
                        </v-list-item-title>
                        <v-list-item-subtitle class="body-2">
                          <strong v-if="BMI">
                            {{ BMI.toFixed(1) }} ({{ BMILevelMessage }})
                          </strong>
                          <span v-else>
                            N/A
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="client.isSedentary"
                        label="¿Lleva un estilo de vida activo o con actividad física? *"
                        :rules="[rules.requiredBool]"
                        class="mt-0"
                    >
                      <v-radio
                          label="Sí"
                          :value="false"
                      />
                      <v-radio
                          label="No"
                          :value="true"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="mainFoodMoment"
                        label="¿Cuál es el momento del día en el que come más? *"
                        :rules="[rules.required]"
                        class="mt-0"
                        @change="resetLeastFoodMoment"
                    >
                      <v-radio
                          label="Desayuno"
                          value="BREAKFAST"
                          :disabled="leastFoodMoment === 'BREAKFAST'"
                          color="green"
                      />
                      <v-radio
                          label="Comida"
                          value="LUNCH"
                          :disabled="leastFoodMoment === 'LUNCH'"
                          color="green"
                      />
                      <v-radio
                          label="Cena"
                          value="DINNER"
                          :disabled="leastFoodMoment === 'DINNER'"
                          color="green"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-radio-group
                        v-model="leastFoodMoment"
                        label="¿Cuál es el momento del día en el que come menos? *"
                        :rules="[rules.required]"
                        class="mt-0"
                    >
                      <v-radio
                          label="Desayuno"
                          value="BREAKFAST"
                          :disabled="mainFoodMoment === 'BREAKFAST'"
                          color="green"
                      />
                      <v-radio
                          label="Comida"
                          value="LUNCH"
                          :disabled="mainFoodMoment === 'LUNCH'"
                          color="green"
                      />
                      <v-radio
                          label="Cena"
                          value="DINNER"
                          :disabled="mainFoodMoment === 'DINNER'"
                          color="green"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 3: Additional Information -->
            <v-stepper-content step="3">
              <v-form ref="formAdditionalInfo">
                <v-row class="mt-2">
                  <v-col cols="12" md="6">
                    <v-combobox
                        v-model="client.beverages"
                        :items="beveragesOptions"
                        item-text="name"
                        item-value="id"
                        label="Bebidas que consume con frecuencia"
                        outlined
                        multiple
                        chips
                        clearable
                        deletable-chips
                        small-chips
                        persistent-hint
                        hint="Selecciona o agrega nuevas opciones. Pulsa Enter para agregar una opción nueva."
                        no-data-text="No se encontraron opciones"
                        prepend-inner-icon="mdi-cup"
                        @change="formatCatalog('beverages', $event)"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-combobox
                        v-model="client.medications"
                        :items="medicationsOptions"
                        item-text="name"
                        item-value="id"
                        label="Medicamentos que toma con frecuencia"
                        outlined
                        multiple
                        chips
                        clearable
                        deletable-chips
                        small-chips
                        persistent-hint
                        hint="Selecciona o agrega nuevas opciones. Pulsa Enter para agregar una opción nueva."
                        no-data-text="No se encontraron opciones"
                        prepend-inner-icon="mdi-pill"
                        @change="formatCatalog('medications', $event)"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-combobox
                        v-model="client.ailments"
                        :items="ailmentsOptions"
                        item-text="name"
                        item-value="id"
                        label="Enfermedades o afecciones que padece"
                        outlined
                        multiple
                        chips
                        clearable
                        deletable-chips
                        small-chips
                        persistent-hint
                        hint="Selecciona o agrega nuevas opciones. Pulsa Enter para agregar una opción nueva."
                        no-data-text="No se encontraron opciones"
                        prepend-inner-icon="mdi-book-heart"
                        @change="formatCatalog('ailments', $event)"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-combobox
                        v-model="client.diets"
                        :items="dietsOptions"
                        item-text="name"
                        item-value="id"
                        label="Dietas que ha seguido o sigue actualmente"
                        outlined
                        multiple
                        chips
                        clearable
                        deletable-chips
                        small-chips
                        persistent-hint
                        hint="Selecciona o agrega nuevas opciones. Pulsa Enter para agregar una opción nueva."
                        no-data-text="No se encontraron opciones"
                        prepend-inner-icon="mdi-food"
                        @change="formatCatalog('diets', $event)"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                        v-model="client.notes"
                        label="Notas adicionales del dietista (opcional)"
                        outlined
                        no-resize
                        rows="4"
                        counter
                        maxlength="255"
                        placeholder="Aquí puedes agregar cualquier información adicional que consideres relevante para el seguimiento del tratamiento del cliente."
                        prepend-inner-icon="mdi-file-document"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>

            <!-- Step 4: Level 1 table details -->
            <v-stepper-content step="4">
              <v-form ref="formTableDetails">
                <v-row class="mt-2">
                  <v-col cols="12" lg="3">
                    <v-select
                        label="Snack 1 (g)"
                        :items="snackOptions"
                        item-text="text"
                        item-value="value"
                        v-model="morningSnack"
                        outlined
                        dense
                        no-data-text="No hay opciones disponibles"
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" lg="1" align-self="center" class="text-center">
                    <v-btn
                        icon
                        small
                        color="primary"
                        @click="swapSnacks()"
                    >
                      <v-icon>mdi-swap-horizontal</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-select
                        label="Snack 2 (g)"
                        :items="snackOptions"
                        item-text="text"
                        item-value="value"
                        v-model="eveningSnack"
                        outlined
                        dense
                        no-data-text="No hay opciones disponibles"
                        hide-details
                    />
                  </v-col>
                  <v-col cols="12" lg="5" class="text-end">
                    <v-chip color="primary" v-if="BMI">
                      IMC: {{ BMI.toFixed(1) }} ({{ BMILevelMessage }})
                    </v-chip>
                  </v-col>

                  <v-col cols="12" lg="3">
                    <v-text-field
                        label="Porcentaje en desayuno (%)"
                        v-model.number="breakfastPercentage"
                        type="number"
                        outlined
                        dense
                        min="1"
                        :max="breakfastPercentageThreshold"
                        prefix="%"
                        reverse
                        :rules="[rules.required, rules.minPercentage]"
                    />
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field
                        label="Porcentaje en comida (%)"
                        v-model.number="lunchPercentage"
                        type="number"
                        outlined
                        dense
                        min="1"
                        :max="lunchPercentageThreshold"
                        prefix="%"
                        reverse
                        :rules="[rules.required, rules.minPercentage]"
                    />
                  </v-col>
                  <v-col cols="12" lg="3">
                    <v-text-field
                        label="Porcentaje en cena (%)"
                        v-model.number="dinnerPercentage"
                        type="number"
                        outlined
                        dense
                        min="1"
                        :max="dinnerPercentageThreshold"
                        prefix="%"
                        reverse
                        :rules="[rules.required, rules.minPercentage]"
                    />
                  </v-col>
                  <v-col cols="12" lg="3" class="text-end">
                    <v-chip :color="isValidPercentage ? 'green' : 'red'" dark>
                      Total: {{ foodPercentageTotal }}%
                    </v-chip>
                    <small v-if="foodPercentageTotal !== 100" class="red--text">
                      El total debe ser 100%
                    </small>
                    <small v-else-if="breakfastPercentage < 1 || lunchPercentage < 1 || dinnerPercentage < 1"
                           class="red--text">
                      Cada comida debe tener al menos 1%
                    </small>
                  </v-col>

                  <v-col cols="12">
                    <v-divider></v-divider>
                  </v-col>

                  <v-col cols="12" lg="5" class="mt-4">
                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formattedAppointmentDateTime"
                            label="Próxima cita"
                            prepend-inner-icon="mdi-calendar-clock-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            dense
                            clearable
                            @click:clear="selectedDate = null; selectedTime = null"
                            :rules="[rules.required]"
                        />
                      </template>

                      <v-card>
                        <v-tabs
                            v-model="activeTab"
                            background-color="primary"
                        >
                          <v-tab>
                            Fecha
                          </v-tab>
                          <v-tab :disabled="!selectedDate">
                            Hora
                          </v-tab>

                          <v-tab-item>
                            <v-date-picker
                                v-model="selectedDate"
                                first-day-of-week="1"
                                locale="es-MX"
                                :min="minimumDate"
                                :max="maximumDate"
                                scrollable
                                @input="activeTab = 1"
                                @click:clear="selectedDate = null; selectedTime = null"
                            />
                          </v-tab-item>

                          <v-tab-item>
                            <v-time-picker
                                v-model="selectedTime"
                                scrollable
                            />
                          </v-tab-item>
                        </v-tabs>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              small
                              color="primary"
                              @click="menu = false; activeTab = 0"
                              :disabled="!selectedDate || !selectedTime"
                          >
                            Aceptar
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Actions -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton
            @click="handleDialogClose"
            :isDisabled="isLoading"
        />
        <v-btn
            color="primary"
            @click="currentStep--"
            :disabled="isLoading || currentStep === 1"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Anterior
        </v-btn>
        <v-btn
            v-if="currentStep < 4"
            color="primary"
            @click="goToNextStep"
            :disabled="isLoading || !isCurrentFormValid"
        >
          Siguiente
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
        <CreateButton
            v-if="currentStep === 4"
            color="primary"
            @click="createClient"
            :isDisabled="!isCurrentFormValid"
            :isLoading="isLoading"
            label="Registrar expediente"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import {cities, provinces} from "@/utils/Locations";

import {NewClient} from "@/services/clients/entities/NewClient";
import {CatalogElement} from "@/services/catalogs/entities/CatalogElement";

import CatalogService from "@/services/catalogs/CatalogService";
import ClientService from "@/services/clients/ClientService";

import throwSuccessMessage from "@/utils/SuccessMessage";
import throwErrorMessage from "@/utils/ErrorMessage";
import {BMILevel, formatDateToISO, snackCalculator} from "@/utils/UniversalFunctions";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "DialogCreateClient",
  components: {CreateButton, CancelButton},
  data() {
    return {
      // Client
      client: {} as NewClient,
      morningSnack: 0 as number,
      eveningSnack: 0 as number,
      wristCircumference: null as number | null,
      mainFoodMoment: '' as 'BREAKFAST' | 'LUNCH' | 'DINNER' | '',
      leastFoodMoment: '' as 'BREAKFAST' | 'LUNCH' | 'DINNER' | '',
      foodMoments: ['BREAKFAST', 'LUNCH', 'DINNER'] as string[],
      selectedDate: null as string | null,
      selectedTime: null as string | null,

      // Date of birth selectors
      selectedDay: null as number | null,
      selectedMonth: null as number | null,
      selectedYear: null as number | null,

      // Months
      months: [
        {text: 'Enero', value: 1},
        {text: 'Febrero', value: 2},
        {text: 'Marzo', value: 3},
        {text: 'Abril', value: 4},
        {text: 'Mayo', value: 5},
        {text: 'Junio', value: 6},
        {text: 'Julio', value: 7},
        {text: 'Agosto', value: 8},
        {text: 'Septiembre', value: 9},
        {text: 'Octubre', value: 10},
        {text: 'Noviembre', value: 11},
        {text: 'Diciembre', value: 12},
      ],

      // Table details
      snackOptions: [
        {text: 'Sin snack', value: 0},
        {text: '25 g', value: 25},
        {text: '50 g', value: 50},
        {text: '75 g', value: 75},
        {text: '100 g', value: 100},
        {text: '150 g', value: 150},
      ],
      mostFoodRecommendedPercentage: 40 as number,
      middleFoodRecommendedPercentage: 35 as number,
      leastFoodRecommendedPercentage: 25 as number,
      breakfastPercentage: 0 as number,
      lunchPercentage: 0 as number,
      dinnerPercentage: 0 as number,

      // Catalogs
      beveragesOptions: [] as CatalogElement[],
      medicationsOptions: [] as CatalogElement[],
      ailmentsOptions: [] as CatalogElement[],
      dietsOptions: [] as CatalogElement[],

      // Appointment date-time picker
      menu: false as boolean,
      activeTab: 0 as number,

      // Calculations
      MALE_FACTORS: {
        "LARGE": 26.9,
        "MEDIUM": 25.7,
        "SMALL": 24.5
      } as Record<string, number>,
      FEMALE_FACTORS: {
        "LARGE": 0.1,
        "MEDIUM": 0.05,
        "SMALL": 0
      } as Record<string, number>,

      // Loading
      isLoading: false as boolean,

      // Dialog
      dialog: false as boolean,
      currentStep: 1 as number,

      // Locations
      provinces: provinces,
      cities: [] as string[],

      // Validation
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
        requiredBool: (value: boolean | null) => value !== null || 'Campo requerido',
        counter: (value: string) => (value || '').length <= 50 || 'Máximo 50 caracteres',
        nameCounter: (value: string) => (value || '').length <= 100 || 'Máximo 255 caracteres',
        phone: (value: string) => {
          const pattern = /^\d{3}-\d{3}-\d{4}$/;
          return pattern.test(value) || 'Teléfono inválido';
        },
        centimeter: (value: string) => {
          const isInteger = /^\d+$/.test(value);
          if (!isInteger) return 'Solo se permiten números enteros';
          const numericValue = parseInt(value, 10);
          return (numericValue >= 70 && numericValue <= 250) || 'Ingresa un valor entre 70 y 250';
        },
        kilogram: (value: string) => {
          const isThreeDecimals = /^\d+(\.\d{1,3})?$/.test(value);
          if (!isThreeDecimals) return 'Solo se permiten números con hasta tres decimales';
          const numericValue = parseInt(value, 10);
          return (numericValue >= 30 && numericValue <= 400) || 'Ingresa un valor entre 30 y 400';
        },
        wrist: (value: string) => {
          const isOneDecimal = /^\d+(\.\d)?$/.test(value);
          if (!isOneDecimal) return 'Solo se permiten números con un decimal';
          const numericValue = parseFloat(value);
          return (numericValue >= 10 && numericValue <= 30) || 'Ingresa un valor entre 10 y 30';
        },
        minPercentage: (value: number) => {
          return (value >= 1) || 'El porcentaje debe ser al menos 1%';
        },
      }
    }
  },

  watch: {
    'client.province': function (val: string) {
      this.cities = cities[val] || [];
    },
    mainFoodMoment() {
      this.adjustFoodPercentages();
    },
    leastFoodMoment() {
      this.adjustFoodPercentages();
    },
    BMI() {
      if (this.client.heightCm && this.client.initialWeightKg) {
        const recommendedSnacks = snackCalculator(this.BMI);
        this.morningSnack = recommendedSnacks[0];
        this.eveningSnack = recommendedSnacks[1];
      } else {
        this.morningSnack = 0;
        this.eveningSnack = 0;
      }
    },
    maxDaysInMonth(newMax: number) {
      if (this.selectedDay && this.selectedDay > newMax) {
        this.selectedDay = null;
        this.updateBirthdate();
      }
    },
  },

  computed: {
    years(): number[] {
      const currentYear = new Date().getFullYear();
      const minYear = currentYear - 100;
      const maxYear = currentYear - 14;
      const years = [];
      for (let year = maxYear; year >= minYear; year--) {
        years.push(year);
      }
      return years;
    },
    maxDaysInMonth(): number {
      if (!this.selectedMonth || !this.selectedYear) return 31;
      return new Date(this.selectedYear, this.selectedMonth, 0).getDate();
    },
    dayRules(): any[] {
      return [
        this.rules.required,
        (value: number) => value >= 1 || 'El día debe ser al menos 1',
        (value: number) => value <= this.maxDaysInMonth || `El mes seleccionado tiene máximo ${this.maxDaysInMonth} días`
      ]
    },
    isCurrentFormValid(): boolean {
      switch (this.currentStep) {
        case 1:
          return (
              !!this.client.name &&
              !!this.client.birthdate &&
              !!this.client.gender &&
              !!this.client.occupation &&
              !!this.client.phone &&
              !!this.client.province &&
              !!this.client.city &&
              !!this.client.district
          );
        case 2:
          return (
              !!this.client.heightCm &&
              !!this.client.initialWeightKg &&
              !!this.wristCircumference &&
              !!this.client.desiredWeightKg &&
              this.client.isSedentary !== undefined &&
              !!this.mainFoodMoment &&
              !!this.leastFoodMoment
          )
        case 3:
          return true; // All fields optional
        case 4:
          return (
              !!this.breakfastPercentage &&
              !!this.lunchPercentage &&
              !!this.dinnerPercentage &&
              this.foodPercentageTotal === 100 &&
              this.breakfastPercentage >= 1 &&
              this.lunchPercentage >= 1 &&
              this.dinnerPercentage >= 1 &&
              !!this.appointmentDateTime
          );
        default:
          return false;
      }
    },
    BMILevelMessage(): string {
      if (!this.BMI) return '';
      return BMILevel(this.BMI);
    },
    BMI(): number {
      if (!this.client.heightCm || !this.client.initialWeightKg) return 0;
      if (this.client.heightCm > 250 || this.client.initialWeightKg > 400) return 0;
      return (this.client.initialWeightKg * 10000) / (this.client.heightCm * this.client.heightCm);
    },
    complexionType(): string | null {
      if (!this.client.heightCm || !this.wristCircumference) return null;
      // round to one decimal
      const ratio = Math.round((this.client.heightCm / this.wristCircumference) * 10) / 10;
      if (ratio >= 10.5) {
        return 'SMALL';
      } else if (ratio >= 9.6) {
        return 'MEDIUM';
      } else {
        return 'LARGE';
      }
    },
    idealWeight(): number {
      if (!this.client.heightCm || !this.client.gender || !this.complexionType) return 0;
      if (this.client.heightCm > 250) return 0;
      const height2 = this.client.heightCm * this.client.heightCm;
      let factor = 0;
      if (this.client.gender === "MALE") {
        factor = this.MALE_FACTORS[this.complexionType];
        return (height2 * factor) / 10000;
      } else {
        const baseWeight = (height2 * 21.5) / 10000;
        factor = this.FEMALE_FACTORS[this.complexionType];
        return baseWeight + (baseWeight * factor);
      }
    },
    overweight(): number {
      if (!this.client.initialWeightKg || !this.idealWeight) return 0;
      return this.client.initialWeightKg - this.idealWeight;
    },
    eatingOrder(): string[] {
      if (!this.mainFoodMoment || !this.leastFoodMoment) return [];
      const middleFoodMoment = this.foodMoments.find(
          moment => moment !== this.mainFoodMoment && moment !== this.leastFoodMoment
      );
      return [this.mainFoodMoment, middleFoodMoment!, this.leastFoodMoment];
    },
    foodPercentageTotal(): number {
      if (!this.breakfastPercentage || !this.lunchPercentage || !this.dinnerPercentage) {
        return 0;
      }
      return this.breakfastPercentage + this.lunchPercentage + this.dinnerPercentage;
    },
    breakfastPercentageThreshold(): number {
      return 100 - this.lunchPercentage - this.dinnerPercentage;
    },
    lunchPercentageThreshold(): number {
      return 100 - this.breakfastPercentage - this.dinnerPercentage;
    },
    dinnerPercentageThreshold(): number {
      return 100 - this.breakfastPercentage - this.lunchPercentage;
    },
    isValidPercentage(): boolean {
      return this.foodPercentageTotal === 100 &&
          this.breakfastPercentage >= 1 &&
          this.lunchPercentage >= 1 &&
          this.dinnerPercentage >= 1;
    },
    minimumDate(): string {
      const min = new Date();
      min.setHours(0, 0, 0, 0);
      min.setDate(min.getDate() + 7);
      return this.formatLocalToISO(min);
    },
    maximumDate(): string {
      const max = new Date();
      max.setHours(0, 0, 0, 0);
      max.setDate(max.getDate() + 10);
      return this.formatLocalToISO(max);
    },
    appointmentDateTime(): string | null {
      if (!this.selectedDate || !this.selectedTime) return null;
      return `${this.selectedDate}T${this.selectedTime}:00`;
    },
    formattedAppointmentDateTime(): string | null {
      if (!this.appointmentDateTime) return null;
      const date = new Date(this.appointmentDateTime);
      const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
      return new Intl.DateTimeFormat('es-MX', options).format(date);
    },
    formattedBirthdate(): string | null {
      if (!this.client.birthdate) return null;
      const [year, month, day] = this.client.birthdate.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      return new Intl.DateTimeFormat('es-MX', options).format(date);
    },
    currentAgeDisplay(): string | null {
      if (!this.selectedYear || !this.selectedMonth || !this.selectedDay) return null;

      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      let age = currentYear - this.selectedYear;
      const monthDiff = currentMonth - this.selectedMonth;
      const dayDiff = currentDay - this.selectedDay;

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return `${age} años`;
    }
  },

  methods: {
    handleDialogClose() {
      this.dialog = false;
      this.client = {} as NewClient;
      this.morningSnack = 0;
      this.eveningSnack = 0;
      this.selectedDate = null;
      this.selectedTime = null;
      this.selectedDay = null;
      this.selectedMonth = null;
      this.selectedYear = null;
      this.currentStep = 1;
      this.wristCircumference = null;
      this.mainFoodMoment = '';
      this.leastFoodMoment = '';
      this.breakfastPercentage = 0;
      this.lunchPercentage = 0;
      this.dinnerPercentage = 0;
      // Reset form validations
      (this.$refs.formCreateClient as Vue & { resetValidation: () => void }).resetValidation();
      (this.$refs.formRegisterFile as Vue & { resetValidation: () => void }).resetValidation();
      (this.$refs.formAdditionalInfo as Vue & { resetValidation: () => void }).resetValidation();
      (this.$refs.formTableDetails as Vue & { resetValidation: () => void }).resetValidation();
    },
    async createClient() {
      this.isLoading = true;
      try {
        const body: NewClient = {
          name: this.client.name,
          occupation: this.client.occupation,
          province: this.client.province,
          city: this.client.city,
          district: this.client.district,
          phone: this.client.phone,
          gender: this.client.gender,
          birthdate: this.client.birthdate,
          heightCm: this.client.heightCm,
          complexion: this.complexionType!,
          wristCircumferenceCm: this.wristCircumference!,
          initialWeightKg: this.client.initialWeightKg,
          idealWeightKg: this.idealWeight,
          desiredWeightKg: this.client.desiredWeightKg,
          eatingOrder: this.eatingOrder,
          isSedentary: this.client.isSedentary,
          type: this.client.type,
          currencyType: "MXN", //TODO: Allow user to select currency type
          unitSystem: "METRIC", // TODO: Allow user to select unit system
          nextAppointment: this.appointmentDateTime,
          breakfastPercentage: this.breakfastPercentage,
          lunchPercentage: this.lunchPercentage,
          dinnerPercentage: this.dinnerPercentage,
          morningSnack: this.morningSnack,
          eveningSnack: this.eveningSnack,
          notes: this.client.notes,
          ailments: this.client.ailments,
          beverages: this.client.beverages,
          diets: this.client.diets,
          medications: this.client.medications,
        }
        const response = await ClientService.createClient(body);
        await this.$store.dispatch('balance/updateBalance')
        await this.$store.dispatch('balance/updateRoyalties', body);
        throwSuccessMessage('Expediente registrado con éxito.');
        this.$emit('created', response);
        this.handleDialogClose();
      } finally {
        this.isLoading = false;
      }
    },
    async getCatalogs() {
      this.isLoading = true;
      try {
        const response = await CatalogService.getCatalogsList();
        this.beveragesOptions = response.beverages;
        this.medicationsOptions = response.medications;
        this.ailmentsOptions = response.ailments;
        this.dietsOptions = response.diets;
      } finally {
        this.isLoading = false;
      }
    },
    goToNextStep() {
      switch (this.currentStep) {
        case 1:
          const createClientForm = this.$refs.formCreateClient as any;
          createClientForm.validate() ?
              this.currentStep++ :
              throwErrorMessage('Por favor, completa todos los campos requeridos correctamente.');
          this.getCatalogs();
          break;
        case 2:
          const registerFileForm = this.$refs.formRegisterFile as any;
          registerFileForm.validate() ?
              this.currentStep++ :
              throwErrorMessage('Por favor, completa todos los campos requeridos correctamente.');
          break;
        case 3:
          const additionalInfoForm = this.$refs.formAdditionalInfo as any;
          additionalInfoForm.validate() ?
              this.currentStep++ :
              throwErrorMessage('Por favor, completa todos los campos requeridos correctamente.');
          break;
        case 4:
          break;
        default:
          break;
      }
    },
    swapSnacks() {
      const temp = this.morningSnack;
      this.morningSnack = this.eveningSnack;
      this.eveningSnack = temp;
    },
    formatPhone(value: string) {
      if (!value) return;
      if (!this.client) return;
      let digits = value.replace(/\D/g, '');

      if (digits.length > 10) {
        digits = digits.substring(0, 10);
      }

      if (digits.length > 6) {
        this.client.phone = digits.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
      } else if (digits.length > 3) {
        this.client.phone = digits.replace(/(\d{3})(\d{0,3})/, '$1-$2');
      } else {
        this.client.phone = digits;
      }
    },
    resetLeastFoodMoment() {
      if (this.leastFoodMoment === this.mainFoodMoment) this.leastFoodMoment = '';
    },
    preventNonNumeric(event: KeyboardEvent) {
      if (['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
      }
    },
    formatCatalog(catalog: 'beverages' | 'medications' | 'ailments' | 'diets', values: any[]) {
      this.client[catalog] = values.map(item => {
        if (typeof item === 'string' && item.trim() !== '') {
          return {id: '', name: item.trim()};
        }
        return item;
      }).filter(item => item);
    },
    adjustFoodPercentages() {
      if (!this.mainFoodMoment || !this.leastFoodMoment) return;

      const middleFoodMoment = this.foodMoments.find(
          moment => moment !== this.mainFoodMoment && moment !== this.leastFoodMoment
      )!;

      // Set main food moment percentage
      switch (this.mainFoodMoment) {
        case 'BREAKFAST':
          this.breakfastPercentage = this.mostFoodRecommendedPercentage;
          break;
        case 'LUNCH':
          this.lunchPercentage = this.mostFoodRecommendedPercentage;
          break;
        case 'DINNER':
          this.dinnerPercentage = this.mostFoodRecommendedPercentage;
          break;
      }

      // Set least food moment percentage
      switch (this.leastFoodMoment) {
        case 'BREAKFAST':
          this.breakfastPercentage = this.leastFoodRecommendedPercentage;
          break;
        case 'LUNCH':
          this.lunchPercentage = this.leastFoodRecommendedPercentage;
          break;
        case 'DINNER':
          this.dinnerPercentage = this.leastFoodRecommendedPercentage;
          break;
      }

      // Set middle food moment percentage
      switch (middleFoodMoment) {
        case 'BREAKFAST':
          this.breakfastPercentage = this.middleFoodRecommendedPercentage;
          break;
        case 'LUNCH':
          this.lunchPercentage = this.middleFoodRecommendedPercentage;
          break;
        case 'DINNER':
          this.dinnerPercentage = this.middleFoodRecommendedPercentage;
          break;
      }
    },
    updateBirthdate() {
      if (this.selectedDay && this.selectedMonth && this.selectedYear && this.selectedDay <= this.maxDaysInMonth) {
        const monthString = this.selectedMonth.toString().padStart(2, '0');
        const dayString = this.selectedDay.toString().padStart(2, '0');
        this.client.birthdate = `${this.selectedYear}-${monthString}-${dayString}`;
      } else {
        this.client.birthdate = '';
      }
    },
    formatLocalToISO(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }
  },
})
;
</script>

<style scoped>
.text-sm {
  font-size: 0.875rem;
}
</style>